module.exports = __webpack_public_path__ + "static/media/em-229.7ce17de6.png";